import { createSlice } from "@reduxjs/toolkit";

const cars = createSlice({
    name: "cars",
    initialState: {
        makes: [],
        models: [],
        generations: [],
        motors: [],
    },
    reducers: {
        getMakesCar() { },
        getModelsCar() { },
        getGenerationsCar() { },
        getMotorsCar() { },
        resetCombosCar(state, _action) {
            return { ...state, makes: [], models: [], generations: [], motors: [] };
        },
        resetCombosOnMakeChange(state, _action) {
            return { ...state, models: [], generations: [], motors: [] };
        },
        resetCombosOnModelChange(state, _action) {
            return { ...state, generations: [], motors: [] };
        },
        resetCombosOnGenerationChange(state, _action) {
            return { ...state, motors: [] }
        },
        setMakesCar(state, action) {
            const data = Object.values(action.payload);
            return { ...state, makes: data };
        },
        setModelsCar(state, action) {
            const data = Object.values(action.payload);
            return { ...state, models: data };
        },
        setGenerationsCar(state, action) {
            const data = Object.values(action.payload);
            return { ...state, generations: data };
        },
        setMotorsCar(state, action) {
            const data = Object.values(action.payload);

            return { ...state, motors: data };
        },
    },
});

export const {
    getMakesCar,
    getModelsCar,
    getGenerationsCar,
    getMotorsCar,
    resetCombosCar,
    resetCombosOnMakeChange,
    resetCombosOnModelChange,
    resetCombosOnGenerationChange,
    setMakesCar,
    setModelsCar,
    setGenerationsCar,
    setMotorsCar
} = cars.actions;

export default cars.reducer;
